module.exports = __webpack_public_path__ + "static/media/location-icon.bd31d9b7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/location-icon.svg
// module id = 1432
// module chunks = 0